import React from "react"

export function Hint({ children }: { children: React.ReactNode }) {
    return (
        <div className="mt-2 rounded bg-yellow-100 p-2 text-sm text-yellow-800">
            {children}
        </div>
    )
}
